import { Flex, MenuProps } from 'antd';
import React from 'react';
import { ReactComponent as PersonFill } from 'assets/icons/PersonFill.svg';
import { FileFilled } from '@ant-design/icons';

export type MenuItem = Required<MenuProps>['items'][number];

export const navigationMenus = [
  {
    key: '/',
    label: 'Mes projets',
    icon: <FileFilled />,
  },
  {
    key: '/profile',
    label: 'Mon profil',
    icon: <PersonFill />,
  },
];
const navigationConfig = (onClick?: (e: any) => void): MenuItem[] =>
  navigationMenus.map((menu) => {
    return {
      ...menu,
      onClick,
      icon: (
        <Flex style={{ width: 24 }} justify={'center'}>
          {menu.icon}
        </Flex>
      ),
    };
  });

export default navigationConfig;
